import { render, staticRenderFns } from "./LecturesFeedbacksStatements.vue?vue&type=template&id=7fdc8953&scoped=true"
import script from "./LecturesFeedbacksStatements.vue?vue&type=script&lang=js"
export * from "./LecturesFeedbacksStatements.vue?vue&type=script&lang=js"
import style0 from "./LecturesFeedbacksStatements.vue?vue&type=style&index=0&id=7fdc8953&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdc8953",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdc8953')) {
      api.createRecord('7fdc8953', component.options)
    } else {
      api.reload('7fdc8953', component.options)
    }
    module.hot.accept("./LecturesFeedbacksStatements.vue?vue&type=template&id=7fdc8953&scoped=true", function () {
      api.rerender('7fdc8953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LecturesFeedbacksStatements.vue"
export default component.exports